import { LogOut } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { useSession } from "@/core/auth/session";
import { Button, type ButtonProps } from "@/ui/button";

/** Signs out here and on the API; says so if the API couldn't be reached (this browser is signed out anyway). */
export function SignOutButton({
  iconOnly = false,
  children = "Sign out",
  ...props
}: { iconOnly?: boolean } & ButtonProps) {
  const { signOut } = useSession();
  const [busy, setBusy] = useState(false);
  const onSignOut = async () => {
    setBusy(true);
    try {
      await signOut();
    } catch {
      toast.error("Couldn't reach Brocoly to sign out. You're signed out on this computer.");
    }
  };
  return (
    <Button
      variant={iconOnly ? "quiet" : "secondary"}
      size={iconOnly ? "icon" : "md"}
      aria-label={iconOnly ? "Sign out" : undefined}
      title={iconOnly ? "Sign out" : undefined}
      loading={busy}
      onClick={() => void onSignOut()}
      {...props}
    >
      {(!busy || !iconOnly) && <LogOut aria-hidden="true" />}
      {!iconOnly && children}
    </Button>
  );
}
